module.exports = __webpack_public_path__ + "static/flags/en-9b86b97ca9f1aa80e06d5f69c77193ff.svg";